import { useProductOptionI18nFormModelContext } from "../../../../../../model";
import { useProductExistingOptionI18nFormModelContext } from "../../../../context";

export const useUpdateButton = () => {
	const { viewModel } = useProductOptionI18nFormModelContext();
	const { onUpdate } = useProductExistingOptionI18nFormModelContext();

	const isValid = !viewModel.hasError && viewModel.isDirty;

	return {
		isValid,
		onUpdate,
	};
};
